export default __webpack_public_path__ + "static/header2b-ed242acdcdc8a8baa40f48e4fca27464.png";